/* Generated by scripts/design_system.py. Do not edit directly. */
window.SaintBreakpoints = Object.freeze({
  "compact": 600,
  "mobile": 750,
  "split": 900,
  "locator": 990,
  "desktop": 1200,
  "wide": 1800
});
